import {
  ChangeDetectionStrategy,
  Component,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
import { StarFilledIconComponent } from '../icons/generated/star-filled/star-filled.component';

const MAX_STARS = 5;
const PRECISSION = 2;

@Component({
  selector: 'app-ratings',
  templateUrl: './ratings.template.html',
  styleUrls: ['./ratings.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgFor, StarFilledIconComponent],
})
export class RatingsComponent {
  @Input() public mode?: 'interactive' | null;
  @Input() public rating?: number | null;
  @Input() public showStarsCount = true;
  @Input() public condensed = false;
  @Input() public showIfEmpty = false;

  @Output() public readonly ratingChange: EventEmitter<number>;

  constructor() {
    this.ratingChange = new EventEmitter();
  }

  public get roundedRating(): string {
    if (this.rating) {
      return this.rating.toFixed(PRECISSION).replace(/[,.]00$/, '');
    }
    return '0';
  }

  public getStars(): Array<string> {
    const stars = new Array(MAX_STARS);
    stars.fill('empty', 0, MAX_STARS);

    if (this.rating) {
      stars.fill('full', 0, this.rating);

      // If the rating is a decimal number, add a half star at the end
      if (this.rating % 1 !== 0) {
        stars[Math.floor(this.rating)] = 'half';
      }
    }

    return stars;
  }

  public onSelectRating(index: number): boolean {
    if (this.mode === 'interactive') {
      this.ratingChange.next(index);
    }
    return false;
  }

  public trackByRating(index: number): string {
    return `${index}`;
  }
}
